import request from '@/utils/request'

// 佣金转积分
export function commissionToJifen(data) {
  return request({
    url: '/user/withdraw/commissionToJifen',
    method: 'post',
    data: data,
  })
}

// 积分转佣金
export function jifenToBalance(data) {
  return request({
    url: '/user/jifen/jifenToBalance',
    method: 'post',
    data: data,
  })
}

// 模拟登录
export function imitationLogin(data) {
  return request({
    url: '/user/imitationLogin',
    method: 'post',
    data: data,
  })
}

// 取得商户列表
export function userNameList() {
  return request({
    url: '/user/userNameList',
    method: 'get',
  })
}

// 用户上下线记录
export function loginRecordList(params) {
  return request({
    url: '/user/loginRecordList',
    method: 'get',
    params: params,
  })
}

// 调整积分余额
export function adjustJifenBalance(data) {
  return request({
    url: '/user/jifen/adjustJifenBalance',
    method: 'post',
    data: data,
  })
}

export function agentRecycel(data) {
  return request({
    url: '/user/jifen/agent/recycle',
    method: 'post',
    data: data,
  })
}

export function agentTopup(data) {
  return request({
    url: '/user/jifen/agent/topUp',
    method: 'post',
    data: data,
  })
}

export function replacePayPassword(data) {
  return request({
    url: '/user/replacePayPassword',
    method: 'post',
    data: data,
  })
}

export function updatePayPassword(data) {
  return request({
    url: '/user/updatePayPassword',
    method: 'post',
    data: data,
  })
}

export function replacePassword(data) {
  return request({
    url: '/user/replacePassword',
    method: 'post',
    data: data,
  })
}

export function getOrderFeeDetailList(params) {
  return request({
    url: '/user/record/orderFeeDetailList',
    method: 'get',
    params: params,
  })
}

export function getJifenBalanceChangeDetailList(params) {
  return request({
    url: '/user/record/jifenBalanceChangeDetailList',
    method: 'get',
    params: params,
  })
}

export function getBalanceChangeDetailList(params) {
  return request({
    url: '/user/record/balanceChangeDetailList',
    method: 'get',
    params: params,
  })
}

export function updatePassword(data) {
  return request({
    url: '/user/updatePassword',
    method: 'post',
    data: data,
  })
}

export function clearVerifyCode(id) {
  return request({
    url: `/user/clearVerifyCode/${id}`,
    method: 'patch',
  })
}

export function status(data) {
  return request({
    url: `/user/updateStatus/${data.id}`,
    method: 'post',
    params: {
      status: data.status
    },
  })
}

export function editUser(data) {
  return request({
    url: `/user/update/${data.id}`,
    method: 'post',
    data: data,
  })
}

// PAY-1583
export function editUserBF(data) {
  return request({
    url: `/user/updateBF/${data.id}`,
    method: 'post',
    data: data,
  })
}

export function editUserRole(data) {
  return request({
    url: '/user/role/update',
    method: 'post',
    data: data,
  })
}

export function getUserRole(id) {
  return request({
    url: `/user/role/${id}`,
    method: 'get',
  })
}

// 新增管理员
export function addAdmin(data) {
  return request({
    url: '/user/addAdmin',
    method: 'post',
    data: data,
  })
}

// 新增商户
export function addSeller(data) {
  return request({
    url: '/user/addSeller',
    method: 'post',
    data: data,
  })
}

// 新增总机
export function addSwitchboard(data) {
  return request({
    url: '/user/addSwitchboard',
    method: 'post',
    data: data,
  })
}

// 新增钱包管理员
export function addWalletAdmin(data) {
  return request({
    url: '/user/addWalletAdmin',
    method: 'post',
    data: data,
  })
}

// 新增钱包提供者
export function addWalletProvider(data) {
  return request({
    url: '/user/addWalletProvider',
    method: 'post',
    data: data,
  })
}

// export function addUser(data) {
//   return request({
//     url: '/user/addUser',
//     method: 'post',
//     data: data,
//   })
// }

export function getUserTypeList() {
  return request({
    url: '/user/type',
    method: 'get',
  })
}

export function getUserList(params) {
  return request({
    url: '/user/list',
    method: 'get',
    params: params,
  })
}

export function getUserById(id) {
  return request({
    url: `/user/${id}`,
    method: 'get',
  })
}

// 提交APP服务申请
export function sendRequestApp(data) {
  return request({
    url: '/user/sendRequestApp',
    method: 'post',
    data: data,
  })
}

// 修改共享积分开关
export function updateSwitchShareJifen(data) {
  return request({
    url: `/user/jifen/updateSwitchShareJifen/${data.id}`,
    method: 'post',
    params: {
      switchShareJifen: data.switchShareJifen
    },
  })
}

// 控制操作员上下线
export function updateOperatorOnlineStatus(data) {
  return request({
    url: '/user/updateOperatorOnlineStatus',
    method: 'post',
    data: data,
  })
}

// 获取用户名称列表
export function getUserNameList(params) {
  return request({
    url: '/user/userNameList',
    method: 'get',
    params: params,
  })
}

// 查询被封锁IP记录
export function getBlockedIpList(params) {
  return request({
    url: '/user/getBlockedIpList',
    method: 'get',
    params,
  })
}

// 解除封锁IP
export function unblockIp(data) {
  return request({
    url: '/user/unblockIp',
    method: 'post',
    data: data,
  })
}

// 登出指定用户
export function logoutUser(data) {
  return request({
    url: '/user/logoutUser',
    method: 'delete',
    data: data,
  })
}


// WEBPACK FOOTER //
// ./src/api/user.js